import { render, staticRenderFns } from "./Orgs.vue?vue&type=template&id=c09d891a&scoped=true&"
import script from "./Orgs.vue?vue&type=script&lang=js&"
export * from "./Orgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09d891a",
  null
  
)

export default component.exports